export default __webpack_public_path__ + "static/media/circles.dd396b71.svg";